/**
 * Types
 */

import type { Status, Step } from '@generatedTypes';

type LifecycleKey = Status | Step;

type TicketLifecycleSource = {
  status?: Status | null;
  workflow_step?: Step | null;
};

/**
 * The single derivation of the lifecycle key: a status wins over the workflow step.
 */
function resolveLifecycleKey(
  ticket: TicketLifecycleSource,
): LifecycleKey | undefined {
  return ticket.status ?? ticket.workflow_step ?? undefined;
}

export type { LifecycleKey, TicketLifecycleSource };

export { resolveLifecycleKey };
